import { render, staticRenderFns } from "./ParcelamentoSimpPrevidenciario.vue?vue&type=template&id=a15dc962&"
import script from "./ParcelamentoSimpPrevidenciario.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoSimpPrevidenciario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports